import React  from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import './config.scss';
import './styles/App.css';
import PageLayout from './PageLayout';
import DashboardPage from './Pages/DashboardPage';
import ProjectsPage from './Pages/ProjectsPage';
import ProjectSetupPage from './Pages/ProjectSetupPage';
import ProjectQuotePage from './Pages/ProjectQuotePage';
import ProjectOverviewPage from './Pages/ProjectOverviewPage';
import ReportPhasePage from './Pages/ReportPhasePage';
import ReportSummaryPage from './Pages/ReportSummaryPage';
import ReportFindingPage from './Pages/ReportFindingPage';
import ProjectRetestPage from './Pages/ProjectRetestPage';
import ProjectRetestListPage from './Pages/ProjectRetestListPage';
import FAQsPage from './Pages/FAQsPage';
import MessagingPage from './Pages/MessagingPage';
import PreferencesPage from './Pages/PreferencesPage';
import UsersManagementPage from './Pages/UsersManagementPage';
import FileTransferPage from './Pages/FileTransferPage';



const App: React.FC = () => {

	return (
		<><Routes>
			
				<Route path='/' element={<PageLayout />}>
					<Route index element={<Navigate to='/dashboard' />} />
					<Route path='dashboard' element={<DashboardPage />} />
					<Route path='projects' element={<ProjectsPage />} />
					<Route path='file-transfer' element={<FileTransferPage />} />
					<Route path='projects' element={<ProjectsPage />} />
					<Route path='usermanagement' element={<UsersManagementPage />} />
					<Route path='projects/:id' element={<ProjectOverviewPage />} />
					<Route path='projects/:id/quote' element={<ProjectQuotePage />} />
					<Route path='projects/:id/setup' element={<ProjectSetupPage />} />
					<Route path='projects/:id/setup/:stageid' element={<ProjectSetupPage />} />
					<Route path='projects/:id/prereqs/:stageid' element={<ProjectSetupPage />} />
					<Route path='projects/:id/:canopyid' element={<ProjectOverviewPage />} />
					<Route path='projects/:id/:canopyid/reports' element={<ReportSummaryPage />} />
					<Route path='projects/:id/:canopyid/reports/:phaseid' element={<ReportPhasePage />} />
					<Route path='projects/:id/:canopyid/reports/:phaseid/finding/:findid' element={<ReportFindingPage />} />
					{/* /retests is the retest table and its Request Retest action; /retest is the
					    request wizard it leads to. Two shapes because the Canopy id is carried through
					    whenever the URL already had one — Crumbs keys off it, and the findings links
					    need it. A project that never reached Canopy uses the shorter form. */}
					<Route path='projects/:id/retests' element={<ProjectRetestListPage />} />
					<Route path='projects/:id/:canopyid/retests' element={<ProjectRetestListPage />} />
					<Route path='projects/:id/retest' element={<ProjectRetestPage />} />
					<Route path='projects/:id/:canopyid/retest' element={<ProjectRetestPage />} />
					<Route path='faqs' element={<FAQsPage />} />
					<Route path='messaging' element={<MessagingPage />} />
					<Route path='preferences' element={<PreferencesPage />} />
					<Route path='preferences/:tab' element={<PreferencesPage />} />			
				</Route>
			</Routes></>	
	);
};

export default App;